<template>
  <DetailDialog
    title="頻回対応"
    icon="mdi-account-group-outline"
    :width="860"
    body-padding="24px"
    cancel-min-width="128"
    :is-saving="isSaving"
    :show-delete="showDelete"
    @cancel="$emit('cancel')"
    @save="save"
    @delete="$emit('delete')"
  >
    <div class="support-detail-grid">
      <div class="field-block">
        <span class="field-label">対応日時</span>
        <DateTimeField v-model="form.supportedAt" />
        <span
          v-if="supportedAtError"
          class="field-error"
        >
          {{ supportedAtError }}
        </span>
      </div>

      <div class="field-block support-type-block">
        <span class="field-label">対応</span>
        <label
          v-for="option in supportTypeOptions"
          :key="option"
          class="choice-row"
        >
          <input
            v-model="form.supportType"
            type="radio"
            :value="option"
            @click="toggleRadio(option)"
          >
          <span>{{ option }}</span>
        </label>
      </div>

      <div class="field-block note-block">
        <span class="field-label">対応補足</span>
        <textarea
          v-model="form.note"
          class="editable-note"
        />
      </div>
    </div>
  </DetailDialog>
</template>

<script>
import DetailDialog from "@/vue/shared/ui/DetailDialog.vue";
import DateTimeField from "@/vue/shared/ui/DateTimeField.vue";
import { toggleRadioSelection } from "@/vue/shared/utils/deselectableRadio";

// 対応種別の表示ラベルと frequent_use_responses.response_type の整数コードの対応。
const SUPPORT_TYPE_TO_CODE = {
  "警告メール送信": 1,
  "制御実施": 2
};
const CODE_TO_SUPPORT_TYPE = {
  1: "警告メール送信",
  2: "制御実施"
};

const supportTypeOptions = ["警告メール送信", "制御実施"];

export default {
  name: "FaceSheetFrequentSupportDetailWindow",
  components: {
    DetailDialog,
    DateTimeField
  },
  props: {
    frequentSupport: {
      type: Object,
      required: true
    },
    // 保存処理中フラグ。true の間は保存ボタンを無効化し連打を防ぐ。
    isSaving: {
      type: Boolean,
      default: false
    },
    // 削除ボタンを表示するかどうか（既存レコードを開いたときのみ true）。
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  emits: ["cancel", "save", "delete"],
  data() {
    return {
      form: this.createForm(this.frequentSupport),
      supportTypeOptions,
      supportedAtError: ""
    };
  },
  watch: {
    frequentSupport: {
      handler(frequentSupport) {
        this.form = this.createForm(frequentSupport);
        this.supportedAtError = "";
      },
      immediate: true
    },
    "form.supportedAt"(value) {
      if (value) this.supportedAtError = "";
    }
  },
  methods: {
    createForm(frequentSupport) {
      const supportTypeFromCode = CODE_TO_SUPPORT_TYPE[frequentSupport?.responseType];
      const supportTypeFromLabel = SUPPORT_TYPE_TO_CODE[frequentSupport?.supportType]
        ? frequentSupport.supportType
        : null;
      return {
        supportedAt: frequentSupport?.supportedAt || "",
        supportType: supportTypeFromCode || supportTypeFromLabel || null,
        note: frequentSupport?.note || ""
      };
    },
    toggleRadio(value) {
      toggleRadioSelection(this.form, "supportType", value);
    },
    save() {
      if (!this.form.supportedAt) {
        this.supportedAtError = "対応日時を入力してください。";
        return;
      }

      this.$emit("save", {
        id: this.frequentSupport?.id,
        lockVersion: this.frequentSupport?.lockVersion,
        responded_at: this.form.supportedAt,
        response_type: SUPPORT_TYPE_TO_CODE[this.form.supportType] ?? null,
        note: this.form.note
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.support-detail-grid {
  display: grid;
  gap: 28px;
  grid-template-columns: 180px 120px 1fr;
  position: relative;
  z-index: 1;
}

.field-error {
  display: block;
  margin-top: 4px;
  color: #d32f2f;
  font-size: 12px;
}

@media (max-width: 720px) {
  .support-detail-grid {
    gap: 16px;
    grid-template-columns: 1fr;
  }
}
</style>